import AdjustIcon from '@mui/icons-material/Adjust';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { purchaseOrderStatusProgressTab } from '../../api/url';
import { MuiStack } from '../../components';
import StatusColor from '../../components/atoms/statusColor';
import { useAppSelector } from '../../store/hooks';
import { white } from '../../theme/palette';
// import { CheckStepper } from './assest';
import { purchaseOrderStatusProgressTabApi } from './services/apiCalls';
import { PurchaseOrderTabKeys } from './services/entity';
import { CheckStepper } from '../../assets/images';
var StatusProgressPO = function (props) {
    var _crud$PurchaseOrderTa, _crud$PurchaseOrderTa2, _data$row, _data$row2;
    var data = props.data;
    var crud = useAppSelector(function (state) { return state.crud; });
    var steps = (_crud$PurchaseOrderTa = (_crud$PurchaseOrderTa2 = crud[PurchaseOrderTabKeys.PurchaseOrderStatusProgressTab]) === null || _crud$PurchaseOrderTa2 === void 0 ? void 0 : _crud$PurchaseOrderTa2.data) !== null && _crud$PurchaseOrderTa !== void 0 ? _crud$PurchaseOrderTa : [];
    var request = {
        ParentId: data === null || data === void 0 || (_data$row = data.row) === null || _data$row === void 0 ? void 0 : _data$row.id,
        EntityId: data === null || data === void 0 || (_data$row2 = data.row) === null || _data$row2 === void 0 ? void 0 : _data$row2.SchemaId
    };
    useEffect(function () {
        purchaseOrderStatusProgressTabApi({
            key: PurchaseOrderTabKeys.PurchaseOrderStatusProgressTab,
            request: request,
            url: purchaseOrderStatusProgressTab
        });
    }, []);
    return /*#__PURE__*/ React.createElement(Box, {
        width: "100%"
    }, steps.length > 0 ? steps === null || steps === void 0 ? void 0 : steps.map(function (step, index) { /*#__PURE__*/ return React.createElement(Grid, {
        container: true,
        spacing: 2,
        alignItems: "center",
        sx: {
            marginBottom: '8px'
        },
        key: index
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: "8px"
        }
    }, step.status === "Approved" ? /*#__PURE__*/ React.createElement("img", {
        src: CheckStepper,
        alt: "Check Stepper",
        style: {
            width: '32px',
            height: '32px'
        }
    }) : /*#__PURE__*/ React.createElement(AdjustIcon, {
        color: step.StatusName === "Cancelled" ? "error" : "disabled",
        fontSize: "large"
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            marginTop: '5px',
            width: "2px",
            height: "60px",
            backgroundColor: '#dee4eb',
            marginBottom: "4px"
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary"
    }, step ? new Date(step === null || step === void 0 ? void 0 : step.DateTime).toLocaleString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    }).split(',  ')[0] : '-'), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: '#F4F7FA',
        borderRadius: '8px',
        padding: '10px',
        mt: '10px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        sx: {
            border: "1px solid #DEE4EB",
            borderRadius: "6px",
            columnGap: "5px",
            padding: "3px",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            bgcolor: white
        }
    }, /*#__PURE__*/ React.createElement(StatusColor, {
        status: step.StatusName
    }), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            width: 'max-content'
        },
        variant: "h6",
        id: "status-name"
    }, step.StatusName))))); }) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary"
    }, "No status progress available."));
};
export default StatusProgressPO;
